export enum ReduxTranslateState {
  RESET_STATE = 'TRANSLATE_RESET_STATE',
  REQUEST_LOADING = 'TRANSLATE_REQUEST_LOADING',
  REQUEST_SUCCESS = 'TRANSLATE_REQUEST_SUCCESS',
  REQUEST_FAILED = 'TRANSLATE_REQUEST_FAILED',
}